import { debug as _debug, Rgb } from '@schibsted-nmp/advertising-shared';

export const debug = _debug.withLabel('GAM', Rgb.brownDark, Rgb.cream);
